import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, SmartphoneIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-label="Bonuses" className="bg-obsidian" data-id="element-16" data-mp="avcxel4e1k8y">
      <div className="mx-auto max-w-5xl px-5 py-14 sm:py-20" style={{
      paddingTop: "18px",
      paddingBottom: "19px"
    }} data-id="element-17" data-mp="autfh4eqmvux">
        <h2 className="text-center font-display text-[28px] font-extrabold tracking-tight text-ice sm:text-4xl" data-id="element-18" data-mp="frtl5e7odwli">
          🎁 4 Free Bonuses Included
        </h2>
        <p className="mt-3 text-center text-xs font-bold uppercase tracking-[0.2em] text-amber" data-id="element-19" data-mp="5wruuf1nyohc">
          Included with your purchase
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-20" data-mp="3t0okud98xtry">
          {bonuses.map((b, i) => <motion.article key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-4 rounded-2xl border border-white/[0.08] bg-charcoal p-4 sm:gap-5 sm:p-5" data-id="element-21" data-mp="3t2socu38gqrp" data-mpi={i}>
              <img src={b.cover} alt={`${b.title} bonus cover`} width={1122} height={1402} loading="lazy" decoding="async" sizes="128px" className="h-auto w-24 shrink-0 self-start rounded-md object-contain drop-shadow-[0_14px_20px_rgba(0,0,0,0.5)] sm:w-32" data-id="element-22" data-mp="3df3d9y1f5xo8" />
              <div className="flex min-w-0 flex-1 flex-col" data-id="element-23" data-mp="2zesm0tw76h2j">
                <span className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full bg-amber/10 px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.12em] text-amber ring-1 ring-amber/30" data-id="element-24" data-mp="2ugh9gbeipsgm">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-25" data-mp="33hfd2sl1nxyo" /> Bonus {b.n}
                </span>
                <h3 className="mt-3 font-display text-base font-extrabold leading-snug text-ice sm:text-lg" data-id="element-26" data-mp="npi3eb9zxus4">{b.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-steel" data-id="element-27" data-mp="ipwv3a8xsa2q">{b.desc}</p>
                <p className="mt-auto whitespace-nowrap pt-4 text-sm font-semibold" data-id="element-28" data-mp="3cjpqj5ln96r9">
                  <span className="text-steel" data-id="element-29" data-mp="3hhrbjw2mrg5d">Value </span>
                  <span className="text-steel line-through" data-id="element-30" data-mp="3hk3zqqyzemqv">{b.price}</span>{' '}
                  <span className="font-extrabold text-amber" data-id="element-31" data-mp="3lk4dsai64vxe">FREE</span>
                </p>
              </div>
            </motion.article>)}
        </div>

        <p className="mt-8 flex items-center justify-center gap-2 text-center text-sm font-medium text-steel" data-id="element-32" data-mp="2tsotwo7zxnav">
          <SmartphoneIcon className="h-4 w-4 shrink-0 text-rescue" aria-hidden="true" data-id="element-33" data-mp="2xtidj5eeofxy" />
          Access your materials from your phone, tablet, or computer.
        </p>

        <div className="mt-6 rounded-2xl border border-amber/30 bg-amber/[0.07] px-5 py-5 text-center" data-id="element-34" data-mp="37jtkz1xat79l">
          <p className="font-display text-lg font-extrabold text-ice sm:text-xl" data-id="element-35" data-mp="2a4fovdlctmty">
            💰 Total Bonus Value: <span className="text-steel line-through" data-id="element-36" data-mp="2f393xagahlw8">$120</span>
          </p>
          <p className="mt-1 font-display text-base font-extrabold tracking-wide text-amber sm:text-lg" data-id="element-37" data-mp="2f164y0x5sifd">
            TODAY FREE WITH THE 5 IN 1 COMBO
          </p>
        </div>
      </div>
    </section>;
}